import React, {useEffect, useState} from 'react';
import Footer from "../layout/Footer";
import { useLocalStorage } from "../useLocalStorage";
import "./Point.css";
import Swal from 'sweetalert2';
import toast, { Toaster } from 'react-hot-toast';
import M from "materialize-css";

import banner1 from "../logo.svg"
import { API_URL, CMS_URL, numberWithCommas, THEME_COLOR } from '../constant';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import jwt  from 'jsonwebtoken';
import HeaderBack from '../layout/HeaderBack';
import gift from "../images/icon/giftbox.svg"
import { Button, Stack,TextField, Typography } from '@mui/material';
import TabPanel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import ImageIcon from '@mui/icons-material/Image';
import WorkIcon from '@mui/icons-material/Work';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

const PointDetail = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [memberCode, setMemberCode] = useState("");
    const [value, setValue] = useState("1");
    const [pointHistory, setPointHistory] = useState([])
    const [gifts, setGifts] = useState([])
    const [item, setItem] = useState([])
    const [imageUrl, setImageUrl] = useState([])
    const [isOpenBackdrop, setIsOpenBackdrop] = useState(false);
    const [qty, setQty] = useState([1]);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function decrementQty(){
        if(qty - 1 >= 1){
            setQty(qty-1);
        }
    }

    function incrementQty(){

        setQty(qty*1+1)
    }


    function qtyKeyPress(event){
        if(! (event.charCode >= 46 && event.charCode <= 57)){
            event.preventDefault();
        }
    }
    
    function qtyChange(e){
        let tqty = (!e.target.value || e.target.value=="" || e.target.value == isNaN || e.target.value < 1)? 1: parseInt(e.target.value)
        setQty(tqty)
    }

    function getDetail(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/point/detail/${props.match.params.code}`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    function postRedeem(){
        var myHeaders = new Headers();
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();
        urlencoded.append("code", props.match.params.code);
        urlencoded.append("qty", qty);
        
        var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/point/redeem`, requestOptions)
        .then(response => response.json())
        .catch(error => {});
    }

    async function redeempoint(){
        setIsOpenBackdrop(true);
        let response = await postRedeem();
        if(response && response.status == 200){
            Swal.fire({
                title: "Success Redeem",
                text: response.message,
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: '#ff3d00',
                confirmButtonText: `Done`
            }).then((result)=>{
                if(result.isConfirmed){
                }
            })
            // toast.success(response.message);
            
        }else if(!response){
            toast.error("Something went wrong!");
        }
        else{
            toast.error(response.message);
        }
        setIsOpenBackdrop(false);
    }

    useEffect(async ()=>{
        let detailresponse = await getDetail();
        if(detailresponse && detailresponse.status == 200){
            setItem(detailresponse.data);
            let value = detailresponse.data
            let timgurl = `${CMS_URL}/images/no-image-found.jpg`;
            if(value.ImageName){
                timgurl = `${CMS_URL}/images/upload/product/${value.Code}/${value.ImageName}`;
            }
            setImageUrl(timgurl);
        }else if(!detailresponse){
            toast.error("Something went wrong!");
        }
        else{
            toast.error(detailresponse.message);
        }
        setMemberCode(jwt.decode(token));
    },[]);
    
    return(
        <React.StrictMode>
            <Toaster
                position="bottom-center"
            />
            <HeaderBack title="Detail"/>
            <div className='point-body'>
                <div>
                    <Card sx={{ width: '100%', display: 'flex',alignItems:'center' }}>
                        <CardMedia
                            component="img"
                            sx={{ width: 151 }}
                            image={imageUrl}
                            alt={item.Name}
                        />
                        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                            <CardContent sx={{ flex: '1 0 auto',alignItems:'center' }}>
                                <Typography component="div" variant="h6">
                                    {item.Name}
                                </Typography>
                                <div className="cart-qty-container">
                                    <div className="cart-qty-input">
                                        <div className="cart-button" onClick={()=> decrementQty()}>
                                            -
                                        </div>
                                        <div style={{width: "17%"}} >
                                            <input type="text" value={qty}  onChange={qtyChange} onKeyPress={qtyKeyPress} />
                                        </div>
                                        <div className="cart-button" onClick={()=> incrementQty()}>
                                            +
                                        </div>
                                    </div>
                                </div>
                                <Typography variant="subtitle1" color="text.secondary" component="div">
                                    Point : {item.RedeemPoint}
                                </Typography>
                                    <a href="#" className={`btn ${THEME_COLOR}`} onClick={()=>redeempoint()}>Redeem</a>
                            </CardContent>
                        </Box>
                    </Card>    
                </div>
                <br/>
                <TabContext value={value}>
                    <TabList onChange={handleChange} aria-label="lab API tabs example" centered variant='fullWidth'>
                        <Tab label="Description" value="1" />
                        <Tab label="Term & Condition" value="2" />
                    </TabList>
                    <TabPanel value="1">{item.Description}</TabPanel>
                    <TabPanel value="2">
                        <div className='point-description'>
                            <p>*Note: Setiap pembelanjaan ke web akan mendapatkan poin yg bisa diakumulasi. Nilai poin yang akan didapatkan bisa dilihat langsung ketika Anda order.</p>

                            <p>Tukar poin Anda dengan hadiah-hadiah di bawah ini, GRATIS tanpa diundi. Mohon untuk diperhatikan syarat dan ketentuan dalam penukaran poin:</p>

                            <ul style={{listStyleType:"disc", border:"0", paddingLeft:"20px"}}>
                                <li className=''>Pajak hadiah ditanggung oleh pemenang.</li>
                                <li className=''>Ketersediaan warna atau tipe produk dapat berubah sewaktu - waktu tergantung stok yang tersedia saat ini.</li>
                                <li className=''>Nilai poin tidak mengikat, dapat berubah jika ada perubahan harga dari Vendor.</li>
                                <li className=''>Ongkos pengirman ditanggung oleh Reseller.</li>
                            </ul>
                        </div>
                    </TabPanel>
                </TabContext>
            </div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isOpenBackdrop}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </React.StrictMode>
    );
}


export default PointDetail;